export const isWindowLoad = (): boolean => typeof window !== 'undefined';

export const checkIfRouteIsActive = (routeList: Array<string>, path: string): boolean => {
  return routeList.some((route) => path.startsWith(route));
};
